export default {
  state: {
    isYoutubeLoaded: false
  }
}
